import React from 'react';
import './footer.css';
import headband from '../../assets/headband.png';
import mail from '../../assets/mail.png';
import insta from '../../assets/insta.png';

const Footer = () => {

  return (
    <div className='footer-main'>

      <div className='footer-border'></div>

      <div className='center-image'>
      <div className='center-image-one'>
      <h1 className='footer-contact'> CONTACT US</h1>
      <div className='footer-components'>

        <div className='links'>

          <div className='mail'>
          <a href="mailto:ubcmuaythai@gmail.com">
            <img className='mailimg' src={mail} alt="mail"/>
            <span className='mailhandle'>ubcmuaythai@gmail.com</span>
            </a>
          </div>

          <a href="https://www.instagram.com/ubcmuaythai/" target="_blank" rel="noopener noreferrer">
          <div className='insta'>
            <img className='instaimg'src={insta} alt="insta"/>
            <span className='instahandle'>@ubcmuaythai</span>
          </div>
          </a>
          
        </div>

        </div>
        </div>


          <div className='headband'>
            <img src={headband} alt="headband"/>
          </div>

        


        </div>
      </div>


  )
}

export default Footer